import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const FAQSection = styled.section`
  padding: 4.5rem 1.5rem;
  background: transparent;
  
  @media (max-width: 1024px) {
    padding: 3rem 1rem;
  }
`;

const FAQContainer = styled.div`
  max-width: 920px;
  margin: 0 auto;
`;

const FAQTitle = styled.h2`
  margin-bottom: 1.5rem;
  font-size: clamp(2rem, 3vw, 2.8rem);
  color: var(--color-text-primary);
  font-weight: 700;
`;

const FAQItem = styled.div`
  margin-bottom: 0.8rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-medium);
  overflow: hidden;
  background: var(--color-surface);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    border-color: rgba(30, 64, 175, 0.24);
    box-shadow: var(--shadow-soft);
  }
`;

const Question = styled.button`
  width: 100%;
  text-align: left;
  padding: 1rem 1.1rem;
  background: var(--color-surface);
  border: none;
  font-size: 1.1rem;
  font-weight: 500;
  color: var(--color-text-primary);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--color-surface-alt);
  }

  span {
    font-size: 1.4rem;
    color: var(--color-accent);
    transition: transform 0.3s ease;
  }
`;

const Answer = styled.div<{ $isOpen: boolean }>`
  padding: ${props => props.$isOpen ? '0 1.1rem 1.1rem 1.1rem' : '0 1.1rem'};
  max-height: ${props => props.$isOpen ? '500px' : '0'};
  opacity: ${props => props.$isOpen ? '1' : '0'};
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  color: var(--color-text-secondary);
  line-height: 1.6;
  font-size: 1.1rem;
`;

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { t } = useLanguage();
  
  // 获取FAQ项目，确保设置returnObjects选项为true
  const faqItems = t('faq.items', { returnObjects: true }) as Array<{ question: string; answer: string }>;

  return (
    <FAQSection id="faq">
      <FAQContainer>
        <FAQTitle>{t('faq.title')}</FAQTitle>
        {faqItems.map((faq, index) => (
          <FAQItem key={index}>
            <Question onClick={() => setOpenIndex(openIndex === index ? null : index)}>
              {faq.question}
              <span style={{ transform: openIndex === index ? 'rotate(45deg)' : 'none' }}>+</span>
            </Question>
            <Answer $isOpen={openIndex === index}>
              {faq.answer}
            </Answer>
          </FAQItem>
        ))}
      </FAQContainer>
    </FAQSection>
  );
};

export default FAQ; 
